import { render, staticRenderFns } from "./eb-button.vue?vue&type=template&id=3271526a&"
import script from "./eb-button.vue?vue&type=script&lang=js&"
export * from "./eb-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports